import React from "react";
import { Box, Container, Typography,} from "@mui/material";
import TransitionImg from "../assets/Transition.png";

export default function TransitionSection() {

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: "#fff" }}>
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 6, md: 8 },
        }}
      >
        {/* === Left Text Section === */}
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
            maxWidth: 600,
          }}
        >
          <Typography
            variant="h4"
            fontWeight={800}
            mb={2}
            sx={{
              background: "linear-gradient(90deg, #1565c0, #004ba0)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Transition Management
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ lineHeight: 1.7, fontSize: "1.05rem", mb: 3 }}
          >
            Transition is the period between the two phases and the related process of a building —
            i.e., the period between the project stages and the fully operational stage of the building.
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ lineHeight: 1.7, mb: 3 }}
          >
            The complete transition process starts from the fit-out stage onward, which includes
            thorough snagging of the entire building, its equipment, and various systems — followed by
            their testing and fine-tuning to ensure operational readiness.
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ lineHeight: 1.7, mb: 3 }}
          >
            This process also involves the compilation of complete as-built drawings, manuals,
            test and trial reports, and commissioning documentation. It includes the collection and
            organization of all equipment data and statutory compliance records as per both
            state and central government norms.
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ lineHeight: 1.7 }}
          >
            Our <strong>core technical team</strong>, comprising subject matter experts with vast and
            multifaceted experience, ensures a seamless transition process that adds measurable
            value to your organization and its assets.
          </Typography>
        </Box>

        {/* === Right Image Section === */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: { xs: "center", md: "flex-end" },
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={TransitionImg}
            alt="Transition Management"
            sx={{
              width: { xs: "85%", sm: "75%", md: "100%" },
              maxWidth: 520,
              borderRadius: 0,
              boxShadow: "none",
              objectFit: "contain",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}
